import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

@Injectable()
export class RxHelper implements OnDestroy {
  private readonly _destroyed$ = new Subject<void>();

  public autoUnsubscribe = <T>(src: Observable<T>) => src.pipe(takeUntil(this._destroyed$));

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
